/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
// import * as auth from '../redux/AuthRedux'
// import {login} from '../redux/AuthCRUD'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {login} from '../AuthRequest/indx'
import {Checkout, LoginRequest, UserInfoData} from '../../api/auth'
import {LOG_IN, USER_INFO, USER_VERIFIED} from '../../../../actions'
import {Button} from 'react-bootstrap-v5'
import {useLocation} from 'react-router'
import FadeIn from 'react-fade-in'
import toast, {Toaster} from 'react-hot-toast'
import {AiFillEye, AiFillEyeInvisible} from 'react-icons/ai'

const loginSchema = Yup.object().shape({
  national_code: Yup.string().required(' وارد کردن کد ملی اجباری است  '),
  password: Yup.string()
    .min(3, 'حداقل 8 کاراکتر ')
    .max(50, 'حداکثر 50 کاراکتر  ')
    .required('وارد کردن رمز عبور اجباری است  '),
})

const initialValues = {
  national_code: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/
function useQuery() {
  const {search} = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      LoginRequest(values.national_code, values.password)
        .then((res) => {
          console.log('auth response', res)
          dispatch(USER_INFO(res.data.userInfo))
          dispatch(LOG_IN(res.data.token, res.data.erInfo, res.status))
          localStorage.setItem('token', res.data.token)
          setLoading(false)
          // window.location.reload()

          // dispatch(auth.actions.login(res.data.token))
        })
        .catch((err) => {
          setLoading(false)
          console.log('err login', err.response.data)
          setSubmitting(false)
          toast.error('ورود ناموفق، کد ملی و رمز عبور خود را بررسی کنید')
          setStatus('کد ملی    یا رمز عبور اشتباه است ')
        })
    },
  })
  let query = useQuery()
  return (
    <FadeIn>
      <div className={'w-lg-450px'}>
        <Toaster />
        <form
          className='form w-100'
          onSubmit={formik.handleSubmit}
          noValidate
          id='kt_login_signin_form'
        >
          <div className={'text-center'}>
            <a href='#' className='mb-12'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-1.svg')} className='h-85px' />
            </a>
          </div>
          <br />
          <br />
          <br />

          {/* begin::Heading */}
          <div className='text-center mb-10'>
            <h1 className='text-dark mb-3 bk-med'>ورود سهامداران </h1>
            {/*<div className='text-gray-400 fw-bold fs-4'>*/}
            {/*  New Here?{' '}*/}
            {/*  <Link to='/auth/registration' className='link-primary fw-bolder'>*/}
            {/*    Create an Account*/}
            {/*  </Link>*/}
            {/*</div>*/}
          </div>
          {/* begin::Heading */}

          {formik.status ? (
            <div className='mb-lg-15 alert text-start alert-danger'>
              <div className='alert-text text-start font-weight-bold'>{formik.status}</div>
            </div>
          ) : (
            <div></div>
          )}
          {query.get('status') === 'login' && (
            <div className={'bg-green-200 p-5 text-center rounded-pill'}>
              ثبت نام شما با موفقیت انجام شد می توانید وارد حساب خود شوید
            </div>
          )}
          {query.get('status') === 'changepassword' && (
            <div className={'bg-green-200 p-5 text-center rounded-pill'}>
              رمز عبور شما با موفقیت تغییر کرد
            </div>
          )}

          <br />
          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <label className='form-label fw-bolder flex justify-end'>کد ملی </label>
            <input
              placeholder=' کد ملی خود را وارد کنید'
              {...formik.getFieldProps('national_code')}
              className={clsx(
                'form-control form-control-lg form-control-solid text-center',
                {'is-invalid': formik.touched.national_code && formik.errors.national_code},
                {
                  'is-valid': formik.touched.national_code && !formik.errors.national_code,
                }
              )}
              type='text'
              name='national_code'
              autoComplete='off'
            />
            {formik.touched.national_code && formik.errors.national_code && (
              <div className='fv-plugins-message-container text-right'>
                <span role='alert'>{formik.errors.national_code}</span>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <div className=' mt-n5'>
              <div className=' mb-2'>
                {/* begin::Label */}
                <label className='form-label fw-bolder flex justify-end '>رمز عبور </label>

                {/* end::Label */}
                {/* begin::Link */}
                {/*<Link*/}
                {/*  to='/auth/forgot-password'*/}
                {/*  className='link-primary fs-6 fw-bolder'*/}
                {/*  style={{marginLeft: '5px'}}*/}
                {/*>*/}
                {/*  Forgot Password ?*/}
                {/*</Link>*/}
                {/* end::Link */}
              </div>
            </div>
            <div className='flex items-center justify-center flex-row-reverse'>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder='رمز عبور را وارد نمایید'
                autoComplete='off'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control w-12/12 form-control-lg form-control-solid text-center',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
                )}
              />
              <div
                onClick={() => setShowPassword(!showPassword)}
                className='is-invalid p-6 cursor-pointer hover-overlay position-relative mb-2 rounded-pill mr-5  bg-gray-100 hover:bg-gray-200'
              >
                {showPassword ? <AiFillEyeInvisible size={18} /> : <AiFillEye size={18} />}
              </div>
            </div>

            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container text-right'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Action */}
          <div className='text-center flex flex-col  justify-center'>
            <div
              style={{flexDirection: 'column-reverse'}}
              className={'flex flex-lg-row flex-sm-column flex-md-column'}
            >
              <div className={'lg:w-4/12 sm:w-full'}>
                <Link to='/auth/registration'>
                  <Button
                    variant={'light'}
                    className='btn btn-lg rounded-pill border-primary mb-5'
                    // disabled={formik.isSubmitting || !formik.isValid}
                  >
                    <span className='indicator-label'> ثبت نام </span>
                  </Button>
                </Link>
              </div>
              <div
                style={{width: '100%'}}
                className={'w-8/12 sm:w-full flex justify-center  text-center center'}
              >
                <button
                  type='submit'
                  id='kt_sign_in_submit'
                  className='btn btn-lg bg-teal rounded-pill text-white w-100 mb-5'
                  // disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && <span className='indicator-label'>ورود </span>}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      ... در حال ورود
                      <span className='spinner-border spinner-border-sm align-middle ms-2' />
                    </span>
                  )}
                </button>
              </div>
            </div>
            <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{marginLeft: '5px'}}
            >
              رمز عبور خود را فراموش کرده اید ؟
            </Link>
          </div>
          {/* end::Action */}
        </form>
      </div>
    </FadeIn>
  )
}
